var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"card fill-height d-flex flex-column py-3"},[_c('v-card-text',{staticClass:"pb-0 pt-1 pr-1 card-body d-flex flex-column fill-height position-relative",class:{
      'pl-2': _vm.maw(460),
      'pl-5': _vm.miw(460)
    }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }